import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import ReactMarkdown from "react-markdown";
import FeedbackButtons from "./FeedbackButtons";

export default function MessageBubble({ message }) {
  const isUser = message.role === "user";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isUser ? "row-reverse" : "row",
        gap: 1.5,
        mb: 2,
      }}
    >
      {!isUser && (
        <Avatar
          src="/images/susie-avatar.png"
          alt="Susie"
          sx={{ width: 72, height: 72, bgcolor: "secondary.main", fontSize: 18, flexShrink: 0 }}
        >
          🐢
        </Avatar>
      )}
      <Box sx={{ maxWidth: "75%" }}>
        <Box
          sx={{
            bgcolor: isUser ? "primary.main" : "background.paper",
            color: isUser ? "primary.contrastText" : "text.primary",
            border: isUser ? "none" : 1,
            borderColor: "divider",
            borderRadius: isUser ? "12px 12px 2px 12px" : "12px 12px 12px 2px",
            px: 2,
            py: 1.5,
            "& p": { margin: 0, lineHeight: 1.7, fontSize: 18 },
            "& p + p": { mt: 1 },
          }}
        >
          {isUser ? (
            <Typography variant="body1" sx={{ fontSize: 18 }}>{message.content}</Typography>
          ) : (
            <ReactMarkdown>{message.content}</ReactMarkdown>
          )}
        </Box>
        {!isUser && message.sources?.length > 0 && (
          <Box sx={{ mt: 0.75, px: 1, display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
            <Typography variant="caption" color="text.disabled" sx={{ fontSize: 11, mr: 0.25 }}>
              Source:
            </Typography>
            {message.sources.map((s, i) => (
              s.uri ? (
                <Box
                  key={i}
                  component="a"
                  href={s.uri}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: 11,
                    color: "text.secondary",
                    textDecoration: "underline",
                    fontFamily: "'PT Serif', Georgia, serif",
                  }}
                >
                  {s.title}
                </Box>
              ) : (
                <Typography key={i} variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
                  {s.title}
                </Typography>
              )
            ))}
          </Box>
        )}
        {!isUser && message.messageId && (
          <FeedbackButtons messageId={message.messageId} />
        )}
      </Box>
    </Box>
  );
}
